import { Transaction, TransactionActivityResponse } from '../hooks/types';

export const filterTransactionActivity = (pages?: TransactionActivityResponse[]): Transaction[] =>
    pages
        ?.flatMap(page => page?.transactions?.data)
        .filter(
            (transaction): transaction is Transaction =>
                transaction !== undefined && transaction.action !== 'credit' && transaction.action !== 'debit'
        ) || [];
